<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="nodesInfoModal" tabindex="-1" role="dialog" aria-labelledby="nodesModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="notesModalHeader" style="text-transform: capitalize">{{ nodeInfo.name }}
              <a data-toggle="tooltip" data-placement="top" title="View Netbox" :href="`https://nb.bigscoots.fullctl.io /dcim/devices/${nodeInfo.id}`" target="_blank" class="mt-2 fs-16 ml-5 text-right" >
                <i class="fa fa-external-link" aria-hidden="true"></i>
              </a>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>

          </div>
          <perfect-scrollbar class="scroll-area">
            <div v-if="!loading && nodeInfo" class="modal-body">
<!--              <div class="text-right mb-5">-->
<!--                <a :href="`https://nb.bigscoots.fullctl.io/api/dcim/devices/${nodeInfo.id}`" target="_blank" class="mt-2 text-right" >-->
<!--                  <i class="fa fa-external-link" aria-hidden="true"></i>-->
<!--                </a>-->
<!--              </div>-->
              <div v-if="nodeInfo.basicInformation" class="card border-left-orange">
                <div class="card-header">
                  <h6><b>Basic Information</b></h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3"><b>Status:</b></div>
                    <div class="col-md-8">
                      <span style="text-transform: capitalize">{{nodeInfo.basicInformation.status || ''}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Name:</b>
                    </div>
                    <div class="col-md-8">
                      {{nodeInfo.basicInformation.name}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Hostname:</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{nodeInfo.basicInformation.hostname}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Server IP:</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{nodeInfo.basicInformation.ip || 'N/A'}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Role:</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{nodeInfo.basicInformation.role}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Rack:</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{nodeInfo.basicInformation.rack}}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="nodeInfo.type === 'wpo' && nodeInfo.solusvm_node_info" class="card border-left-blue">
                <div class="card-header">
                  <h6><b>SolusVM Node Information</b></h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3"><b>SolusVM Node Id:</b></div>
                    <div class="col-md-8">
                      {{nodeInfo.solusvm_node_id}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Virt:</b>
                    </div>
                    <div class="col-md-8">
                      {{nodeInfo.solusvm_node_info.virt || ''}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Free Disk (GB):</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{`${(nodeInfo.solusvm_node_info.freedisk/1024**2).toFixed(2)} GB` || ''}}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Virtual Servers:</b>
                    </div>
                    <div class="col-md-8">
                      <span>{{nodeInfo.solusvm_node_info.virtualservers || '' }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="nodeInfo.clientInfo" class="card border-left-green">
                <div class="card-header">
                  <h6><b>Client Information</b></h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3"><b>Name:</b></div>
                    <div class="col-md-8">
                      {{nodeInfo.clientInfo.name}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Domain:</b>
                    </div>
                    <div class="col-md-8">
                      {{nodeInfo.clientInfo.domain}}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="nodeInfo.serverBuild" class="card border-left-yellow">
                <div class="card-header">
                  <h6><b>Server Build</b></h6>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-md-3"><b>Manufacturer:</b></div>
                    <div class="col-md-8">
                      {{nodeInfo.serverBuild.manufacturer}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3">
                      <b>Motherboard:</b>
                    </div>
                    <div class="col-md-8">
                      {{nodeInfo.serverBuild.motherboard}}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-3"><b>CPU:</b></div>
                    <div class="col-md-8">
                      {{nodeInfo.serverBuild.cpu}}
                    </div>
                  </div><div class="row">
                  <div class="col-md-3"><b>CPU Cores:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.cpuCores}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>RAM:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.ram}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Chasis:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.chasis}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Raid:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.raid}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 0:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_00 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 1:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_01 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 2:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_02 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 3:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_03 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 4:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_04 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 5:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_05 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 6:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_06 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 7:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_07 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 8:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_08 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 9:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_09 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 10:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_10 || 'No Drive'}}
                  </div>
                </div><div class="row">
                  <div class="col-md-3"><b>Drive 11:</b></div>
                  <div class="col-md-8">
                    {{nodeInfo.serverBuild.drive_11 || 'No Drive'}}
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div v-else class="loader"></div>
          </perfect-scrollbar>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';
export default {
  data() {
    return {
      loading: false,
      nodeInfo: {}
    }
  },
  components: { PerfectScrollbar },
  methods: {
    load(node) {
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      $('#nodesInfoModal').modal('show')
      this.fetchNodeInfo(node)
    },
    async fetchNodeInfo(node) {
      try {
        this.loading = true;
        this.nodeInfo = {...node}
        const response = await this.$http.post('/solus-vm/get_single_node_info', {
          grant_type: 'token',
          type: node.type,
          id: node.id,
          solusvm_node_id: node.solusvm_node_id
        })
        console.log('response', response)
        if(response.data.success) {
          this.nodeInfo = { ...node, ...response.data.nodeInfo}
        }
      } catch (e) {
        console.log(`error while fetching single node info ${e.toString()}`)
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style scoped>
.scroll-area {
  position: relative;
  max-height: 750px;
  overflow: hidden;
}
.border-left-orange {
  border: 1px solid lightgray;
  border-left: 4px solid orange;
}.border-left-green {
  border: 1px solid lightgray;
  border-left: 4px solid green;
}.border-left-yellow {
  border: 1px solid lightgray;
  border-left: 4px solid darkmagenta;
}
.border-left-blue {
  border: 1px solid lightgray;
  border-left: 4px solid darkblue;
}

</style>